/**
 * Search toggle
 */

aucor_search_toggle = function(search, options) {
  var extend = function(defaults, options) {
    var extended = {};
    var prop;

    for (prop in defaults) {
        if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
            extended[prop] = defaults[prop];
        }
    }

    for (prop in options) {
        if (Object.prototype.hasOwnProperty.call(options, prop)) {
            extended[prop] = options[prop];
        }
    }

    return extended;
  };

  // Default settings
  var defaults = {
    desktop_min_width: 501,
    search_toggle: document.querySelector('#search-toggle')
  };

  var settings = extend(defaults, options),
  desktop_min_width = settings.desktop_min_width, // match this to $menu-visible SASS variable
  search_toggle = settings.search_toggle,
  screen_w;

  /* Toggle search
  ----------------------------------------------- */

  search_toggle.addEventListener('click', function() {
    if (search_toggle.classList.contains('search-toggle--active')) {

      // remove .active class from search toggle
      search_toggle.classList.remove('search-toggle--active');
      search_toggle.setAttribute('aria-expanded', 'false');
  
      // remove .active class from body and search container
      search.classList.remove('active');
      document.body.classList.remove('search-form--active');
  
    } else {
  
      // .active class to search toggle
      search_toggle.classList.add('search-toggle--active');
      search_toggle.setAttribute('aria-expanded', 'true');
  
      // .active class to body and search container
      search.classList.add('active');
      document.body.classList.add('search-form--active');
      
    }
  });

  return this;
};